import React, { useEffect, useState, useRef, useContext } from "react";
import { StyledContainer } from "./styles";
import classnames from "classnames";
import Textarea from "react-textarea-autosize";
import Card from "..";
import { CardContext } from "../..";
import { SET_CONTENT_ACTION } from "../../hooks/useCanvasReducer";

const MAX_CHARACTER_COUNT = 2500;

export default function LabelCard({
  x, //
  y,
  content,
  width,
  id,
  selected,
  type,
  zoom,
  generating,
  index,
  initialEditing = false,
  autoHeight,
}) {
  const {
    selectedCardIds, //
    setIsEditing,
    dispatch,
  } = useContext(CardContext);

  const [editing, setEditing] = useState(initialEditing);

  const editingRef = useRef(null);

  // true if this is the only card selected
  const onlyThisSelected = selected && selectedCardIds.length === 1;

  // upon selection logic
  useEffect(() => {
    if (!onlyThisSelected) {
      if (editingRef.current) {
        editingRef.current.blur();
      }
      setEditing(false);
    }
  }, [selected, selectedCardIds]);

  // on edit start, focus and place cursor at end
  useEffect(() => {
    if (editing && editingRef.current) {
      editingRef.current.focus();
      editingRef.current.selectionStart = editingRef.current.value.length;
    }
  }, [editing]);

  return (
    <Card
      onEditIntent={(e) => {
        if (onlyThisSelected) {
          // on the second click, we allow editing
          setEditing(true);
        }
      }}
      x={x}
      y={y}
      content={content}
      width={width}
      id={id}
      selected={selected}
      type={type}
      zoom={zoom}
      generating={generating}
      generatable={false}
      index={index}
      naked={true}
      autoHeight={autoHeight}
    >
      <StyledContainer className={classnames("textarea-container", { editing: editing })}>
        <Textarea
          maxLength={MAX_CHARACTER_COUNT}
          placeholder="Add text"
          className={classnames("editable", { "edit-on": editing })}
          ref={editingRef}
          disabled={!editing}
          onChange={(e) => {
            dispatch({ type: SET_CONTENT_ACTION, id: id, content: e.target.value });
            e.stopPropagation();
          }}
          onBlur={(e) => setIsEditing(false)}
          onFocus={(e) => setIsEditing(true)}
          value={content}
          style={{
            height: content === "" ? "42px" : null, // special case on insert avoid flickering on height change, we assume it will be one line height high
          }}
        />
      </StyledContainer>
    </Card>
  );
}
